import "../components/Contact.css";

import MainLayout from "../layouts/MainLayout";
import ContactHero from "../components/ContactHero";
import ContactInfo from "../components/ContactInfo";
import ContactForm from "../components/ContactForm";
import ContactMap from "../components/ContactMap";

export default function Contact() {
  return (
    <MainLayout>
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      {/* <ContactMap /> */}
    </MainLayout>
  );
}